import { mapAdvisorCardProps } from "web_myplann/Advisor/Mappers/mapAdvisorCardProps";
import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const mapAdvisorAssistantCardProps = (
	detail: AgentDetailResponseDTO,
	fallbackJob: string,
) => {
	const {
		linkedin,
		website,
		showMainBadge,
		specializations,
		hspName,
		job,
		...cardProps
	} = mapAdvisorCardProps(detail);

	return { ...cardProps, specializations: [], job: job || fallbackJob };
};
